import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { ChevronDown, LogOut, User as UserIcon, Code2 } from "lucide-react";

export default function Header() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const nav = useNavigate();

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <header className="pa-header" data-testid="app-header">
      <div
        className="pa-container"
        style={{
          height: 64,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <a
          href="/"
          className="pa-logo"
          style={{ textDecoration: "none", fontSize: 17 }}
          data-testid="header-logo"
        >
          <span className="pa-logo-mark">●</span>{" "}
          <span>Portale Acquisizioni</span>{" "}
          <span style={{ color: "var(--pa-muted)", fontWeight: 500 }}>Excel</span>
        </a>

        {user && (
          <div style={{ position: "relative" }} ref={ref}>
            <button
              onClick={() => setOpen((v) => !v)}
              data-testid="user-menu-button"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                padding: "8px 12px",
                background: "transparent",
                border: "1px solid var(--pa-border)",
                borderRadius: 8,
                cursor: "pointer",
                color: "var(--pa-text)",
                fontSize: 14,
              }}
            >
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 26,
                  height: 26,
                  background: "var(--pa-navy)",
                  color: "white",
                  borderRadius: 999,
                  fontSize: 11,
                  fontWeight: 600,
                }}
              >
                {user.nome?.[0]}
                {user.cognome?.[0]}
              </span>
              <span style={{ fontWeight: 500 }}>
                {user.nome} {user.cognome}
              </span>
              <ChevronDown size={14} color="#6B7280" />
            </button>
            {open && (
              <div
                style={{
                  position: "absolute",
                  right: 0,
                  top: "calc(100% + 6px)",
                  background: "white",
                  border: "1px solid var(--pa-border)",
                  borderRadius: 8,
                  minWidth: 220,
                  boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                  padding: 6,
                  zIndex: 50,
                }}
                data-testid="user-menu-dropdown"
              >
                <div
                  style={{
                    padding: "8px 10px",
                    fontSize: 12,
                    color: "var(--pa-muted)",
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <UserIcon size={14} /> {user.email}
                </div>
                <div
                  style={{
                    height: 1,
                    background: "var(--pa-border)",
                    margin: "4px 0",
                  }}
                />
                <button
                  onClick={() => {
                    setOpen(false);
                    nav("/admin/parsers");
                  }}
                  data-testid="header-parsers-link"
                  style={{
                    width: "100%",
                    textAlign: "left",
                    padding: "8px 10px",
                    background: "transparent",
                    border: "none",
                    borderRadius: 6,
                    cursor: "pointer",
                    color: "var(--pa-text)",
                    fontSize: 14,
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = "#F1F2F4")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = "transparent")
                  }
                >
                  <Code2 size={14} /> Parser consulenti
                </button>
                <button
                  onClick={logout}
                  data-testid="logout-button"
                  style={{
                    width: "100%",
                    textAlign: "left",
                    padding: "8px 10px",
                    background: "transparent",
                    border: "none",
                    borderRadius: 6,
                    cursor: "pointer",
                    color: "var(--pa-red)",
                    fontSize: 14,
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = "var(--pa-red-bg)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = "transparent")
                  }
                >
                  <LogOut size={14} /> Esci
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </header>
  );
}
